import { ThemeProvider } from '@dmm-com/turtle-components'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Global } from '@emotion/react'
import { globalStyles } from '@/styles/tailwind-base'
import '@/styles/google-fonts.css'

import { ErrorFallback } from './components/common/Fallback'

/**
 * @param Component
 * @constructor
 */
export function createRoot(Component: JSX.Element) {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <Global styles={globalStyles} />
        <ThemeProvider responsiveTypography={false}>{Component}</ThemeProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
}

/**
 * 描画エラーを捕捉してフォールバックを表示する
 */
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    console.error(error)
  }

  render() {
    return this.state.hasError ? <ErrorFallback /> : this.props.children
  }
}
